export enum Paths {
  Integrations = "/integrations",
  IntegrationNew = "/integrations/new",
  IntegrationView = "/integration/:id"
}
